/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Formations {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Formations as FormationsModule } from "./Formations.jsx"
import { useStaticQuery, graphql } from "gatsby"

const Formations = ({ subtitle, title, suptitle, anchor }) => {
  const { formations } = useStaticQuery(graphql`
    query formationsModulesQuery {
      formations: allCollectionFormations(sort: { date: DESC }) {
        nodes {
          title
          slug
          teaserExcerpt
          teaserImage {
            localImage {
              childImageSharp {
                gatsbyImageData(width: 350, height: 175)
              }
            }
          }
        }
      }
    }
  `)

  if (!formations.nodes) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        anchor,
        //button,
        //buttonPosition: buttonPosition?.value,
      }}
    >
      <FormationsModule formations={formations.nodes} />
    </Section>
  )
}

export { Formations }
